<template>
  <div class="tabs">
    <div 
      v-for="(tab, index) in tabs" 
      :key="index" 
      :class="['tab', {'active-tab': index===activeIndex}]"
      @click.prevent="selectTab(index)"
    >
      <ima-button 
        :title="`${tab.title} (${tab.number})`" 
        size="compressed" 
        :variant="index===activeIndex ? 'accent' : 'default' "
        :fill="index===activeIndex ? '' : 'clear' "
        :act="()=>{}"
      ></ima-button>
    </div>
  </div>
</template>

<script>
import ImaButton from './ImaButton.vue'
export default {
  components: { ImaButton },
  props: {
    tabs: {
      type: Array
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  methods: {
    selectTab(index) {
      this.activeIndex = index;
      this.$emit('input', this.activeIndex)
    }
  }
}
</script>

<style scoped>
.tabs {
  display: flex;
  margin: 16px 0;
}
</style>